import type { Dict } from "../types";

export const personnel: Dict = {
  en: {

    // HairdresserSelector
    "hairdresser.title": "Choose Your Employee",
    "hairdresser.subtitle": "Select your preferred employee",
    "hairdresser.noHairdressers": "No employees available",
    "hairdresser.anyProfessional": "Any Professional",
    "hairdresser.maxAvailability": "Maximum availability",
    "hairdresser.noEmployeeAvailable": "No employee available",
    "hairdresser.noEmployeeAvailableDescription": "No employee is currently available for online booking for the selected service. Please contact the salon directly.",
    "hairdresser.noEmployeeCanPerformAll": "No employee can perform all selected services.",
    "hairdresser.aboutMe": "About Me",
    "hairdresser.interests": "Interests",
    "hairdresser.portfolio": "Portfolio",
    "hairdresser.tellUsAbout": "Tell us about yourself...",

    // HairdresserSelector
    "hairdresser.viewProfile": "View Profile",

    // HairdressersView
    "hairdresserView.quote": "Quote",
    "hairdresserView.quotePlaceholder": "Enter quote",
    "hairdresserView.error": "Error",
    "hairdresserView.nameRequired": "Employee name is required",
    "hairdresserView.aboutMeTooLong": "About me must be 200 characters or less",
    "hairdresserView.noSalonFound": "No salon found",
    "hairdresserView.maxPortfolioImages": "Maximum 6 portfolio images allowed",
    "hairdresserView.selectImageFiles": "Please select only image files",
    "hairdresserView.selectValidImage": "Please select a valid image file",

    // Personnel type
    "Personnel.typeLabel": "Type",
    "Personnel.typePrestataire": "Provider",
    "Personnel.typeAssistant": "Assistant",
    "Personnel.typeReceptionniste": "Receptionist",
    "Personnel.typeGerant": "Manager",
    "Personnel.typeProprietaire": "Owner",
    "Personnel.owner.showOnCalendar": "Show on calendar",
    "Personnel.owner.showOnCalendarHint": "Adds a calendar column for this owner and makes them bookable online.",
    "Personnel.showInPayroll": "Show in payroll",
    "Personnel.showInPayrollHint": "Lists this person in the payroll table. When hidden, they no longer appear there, even with hours or sales in the period.",
    "Personnel.aboutMeMax": "(max 200 characters)",
    "Personnel.color.automatic": "Automatic color",
    "Personnel.charCountSuffix": "/200 characters",
    "Personnel.portfolioMaxImages": "Portfolio (max 6 images)",
    "Personnel.imagePreviewAlt": "Profile picture preview",
    "Personnel.portfolioImageAlt": "Portfolio photo {n}",
    "Personnel.portfolioNewImageAlt": "New portfolio photo {n}",
    "Personnel.statusLabel": "Status",
    "Personnel.statusActive": "Active",
    "Personnel.statusInactive": "Inactive",
    "Personnel.status.lockedRootOwner": "The founding owner of the salon cannot be deactivated. This account created the salon and must stay active.",
    "Personnel.status.lockedSelf": "You cannot deactivate your own record. Ask another owner to do it.",
    "Personnel.deactivateAction": "Mark as inactive (offboarding)",
    "Personnel.reactivateAction": "Reactivate",
    "Personnel.deactivateDialogTitle": "Mark as inactive?",
    "Personnel.deactivateDialogDescription": "This member will be removed from online booking and the calendar, and their login will be disabled. All history (appointments, invoices, payroll, stats) is kept. This is reversible.",
    "Personnel.deactivateDialogConsequences": "Consequences",
    "Personnel.deactivateConsequence1": "No longer visible in online booking",
    "Personnel.deactivateConsequence2": "Removed from the calendar",
    "Personnel.deactivateConsequence3": "Login access disabled",
    "Personnel.deactivateConsequence4": "All history preserved",
    "Personnel.deactivateConsequence5": "Reversible at any time",
    "Personnel.deactivateConfirm": "Confirm deactivation",
    "Personnel.deactivateBlockedMessage": "{count} upcoming appointment(s) must first be reassigned or cancelled.",
    "Personnel.reactivateDialogTitle": "Reactivate this member?",
    "Personnel.reactivateDialogDescription": "This will re-enable their login and make them visible again in booking and the calendar.",
    "Personnel.reactivateConfirm": "Reactivate",
    "Personnel.deleteFiche.label": "Delete account",
    "Personnel.deleteFiche.hint": "Permanently delete the login account. The name is kept on past invoices and appointments.",
    "Personnel.deleteFiche.action": "Delete permanently",
    "Personnel.deleteFiche.dialogTitle": "Permanently delete this account?",
    "Personnel.deleteFiche.dialogDescription": "The login account and personal data are deleted and the email is freed up for reuse. The employee's history (invoices, appointments, payroll) is preserved under their name. This action cannot be undone.",
    "Personnel.deleteFiche.consequence1": "Login account and email permanently deleted",
    "Personnel.deleteFiche.consequence2": "Name preserved on invoices and appointments",
    "Personnel.deleteFiche.consequence3": "Irreversible: the member cannot be reactivated",
    "Personnel.deleteFiche.confirm": "Delete permanently",
    "Personnel.deleteFiche.success": "Account deleted",
    "Personnel.deleteFiche.noAccount.label": "Delete record",
    "Personnel.deleteFiche.noAccount.hint": "Permanently remove this record from the module. The name is kept on past invoices and appointments.",
    "Personnel.deleteFiche.noAccount.dialogTitle": "Permanently delete this record?",
    "Personnel.deleteFiche.noAccount.dialogDescription": "The record disappears from the module for good. The history (invoices, appointments, payroll) is preserved under their name. This person has no login account, so there is nothing to free up. This action cannot be undone.",
    "Personnel.deleteFiche.noAccount.consequence1": "Record removed from the module, permanently",
    "Personnel.deleteFiche.noAccount.consequence2": "Name preserved on invoices and appointments",
    "Personnel.deleteFiche.noAccount.consequence3": "Irreversible: the record cannot be restored",
    "Personnel.deleteFiche.noAccount.success": "Record deleted",
    "Personnel.deleteFiche.failed": "Could not delete the account",
    "Personnel.account.revoke.label": "Remove login access",
    "Personnel.account.revoke.hint": "Delete this login account. The person keeps their file, their history and their appointments.",
    "Personnel.account.revoke.action": "Remove access",
    "Personnel.account.revoke.dialogTitle": "Remove this login account?",
    "Personnel.account.revoke.dialogDescription": "The login account is deleted and the email address becomes available again. You can create a new account on the same file right after.",
    "Personnel.account.revoke.consequence1": "Email address freed up and reusable",
    "Personnel.account.revoke.consequence2": "File, history and appointments untouched",
    "Personnel.account.revoke.consequence3": "The person keeps working here and their file stays active. The seat is still counted, except for an owner who has no active file: that seat is freed.",
    "Personnel.account.revoke.consequence4": "Custom permissions are lost and reset when a new account is created",
    "Personnel.account.revoke.confirm": "Remove access",
    "Personnel.account.revoke.success": "Login access removed",
    "Personnel.account.revoke.failed": "Could not remove the login access",
    "Personnel.account.revoke.modeMismatch": "The server did not do what was asked. The file may have been archived and hidden. Open it and check before going any further.",
    "Personnel.account.revoke.stillReferenced": "This account cannot be deleted because it is still referenced elsewhere in the application. Nothing was changed. Please contact support.",
    "Personnel.account.revoke.refused.self": "You cannot remove your own login account. Ask another owner to do it.",
    "Personnel.account.revoke.refused.founding_owner": "The founding owner's login cannot be removed. This account created the salon and must stay active.",
    "Personnel.account.revoke.refused.last_owner": "This is the last owner login of the salon. Removing it would lock everyone out.",
    "Personnel.account.refused.targetNotStaff": "This account is an owner account or does not belong to your salon's staff. No change was made.",
    "Personnel.account.revoke.lockedRootOwner": "The founding owner's login cannot be removed. This account created the salon and must stay active.",
    "Personnel.account.revoke.lockedSelf": "You cannot remove your own login account. Ask another owner to do it.",

    // PresenceLocationsField (employés multi-succursales)
    "Personnel.presences.title": "Locations where {name} works",
    "Personnel.presences.primary": "Main location of their file",
    "Personnel.presences.removeTitle": "Remove {name} from {location}?",
    "Personnel.presences.futureAppointments": "{count} upcoming appointments at this location. They stay on the calendar.",
    "Personnel.presences.futureAppointmentsError": "Could not check the upcoming appointments at this location. Any existing ones stay on the calendar.",
    "Personnel.presences.removeConfirm": "Remove from {location}",
    "Personnel.presences.removing": "Removing...",
    "Personnel.presences.twoLocationsHint": "Two locations: {name} will see the location switcher in their app.",
    "Personnel.presences.errors.homeSalon": "This location is already the main location of this file.",
    "Personnel.presences.errors.isPrimary": "The main location of a file cannot be removed.",
    "Personnel.presences.errors.mustPointToPrimary": "Open the person's main file to change their locations.",
    "Personnel.presences.errors.notFound": "This location was already removed. Reopen the file to see the current state.",
    "Personnel.presences.errors.primaryDeactivated": "This person is inactive. Reactivate them before adding a location.",
    "Personnel.presences.errors.notAllowed": "You do not have the right to change this person's locations. You need to be an owner, or a manager allowed to add employees in both locations.",
    "Personnel.presences.errors.generic": "Could not update the locations. Please try again.",
    "Personnel.presences.switcherLabel": "Location",
    "Personnel.presences.prefilledBanner": "Prefilled from {location} using the linked services. Nothing is saved yet: review, then save.",
    "Personnel.presences.prefilledFrom": "prechecked from \u201c{service}\u201d",
    "Personnel.presences.priceHint": "{location}: {price}",
    "Personnel.presences.unsavedTitle": "Your changes for {location} are not saved yet.",
    "Personnel.presences.unsavedBody": "Save them before switching locations, or discard them.",
    "Personnel.presences.unsavedStay": "Stay on {location}",
    "Personnel.presences.unsavedDiscard": "Discard and open {location}",
    "Personnel.rates.readOnlyNeedsServices": "Specializations, prices and durations can be changed with the Services permission.",

    // Personnel — Account tab
    "Personnel.account.saveFirst": "Save the profile before creating a login account.",
    "Personnel.account.enterNameFirst": "Enter a name for this person first.",
    "Personnel.account.noAccount": "This team member does not yet have a login account. Create one to give them access to the dashboard.",
    "Personnel.account.createAction": "Create a login account",
    "Personnel.account.createSubmit": "Create account",
    "Personnel.account.associateAction": "Link an existing account",
    "Personnel.account.associateSubmit": "Link account",
    "Personnel.account.associatePlaceholder": "Select an account",
    "Personnel.account.associateEmpty": "No unlinked account available",
    "Personnel.account.successAssociated": "Account linked",
    "Personnel.account.personAlreadyLinked": "This profile is already linked to an account. Remove the current account's access first.",
    "Personnel.account.accountAlreadyLinked": "This account is already linked to another staff profile.",
    "Personnel.account.passwordHint": "Min. 10 characters, with an uppercase letter, a lowercase letter, a number and a special character",
    "Personnel.account.errorPasswordMin10": "Password must be at least 10 characters",
    "Personnel.account.successCreated": "Login account created successfully",
    "Personnel.account.warnPermissionsNotSeeded": "Account created, but default permissions could not be applied. Configure them manually in the Permissions tab.",
    "Personnel.account.accountActive": "Login account",
    "Personnel.account.activeBadge": "Active",
    "Personnel.account.emailUnknown": "Email unavailable",
    "Personnel.account.resetDesc": "Send a password reset email to this team member.",
    "Personnel.account.resetAction": "Send password reset",
    "Personnel.account.resetSent": "Email sent",
    "Personnel.account.resetSentDesc": "The password reset instructions have been sent by email.",

    // Personnel — employee creation (sub-location picker, Phase 6 T15)
    "Personnel.create.locationLabel": "Works at which location?",
    "Personnel.create.locationPlaceholder": "Select a location...",

    // Personnel — unified Employé section
    "Personnel.section.title": "Staff",
    "Personnel.section.addEmployee": "Add employee",
    "Personnel.section.employeeLimitReached": "Employee limit reached ({current}/{max}). Upgrade your plan to add more.",
    "Personnel.section.employeeLimitReachedSalonCap": "Employee limit reached ({current}/{max}). This limit was set for your salon. Contact Flowcut support to raise it.",
    "Personnel.section.empty": "No staff yet. Add your first employee to get started.",
    "Personnel.section.inactiveTitle": "Inactive staff",
    "Personnel.section.orphanTitle": "Accounts without a profile",
    "Personnel.section.orphanDescription": "These login accounts are not linked to any staff profile. Edit a staff member and link the account, or recreate the profile.",
    "Personnel.section.errorLoading": "Unable to load staff. Please try again.",
    "Personnel.section.tabEmployees": "Employees",
    "Personnel.section.tabOwners": "Owners",
    "Personnel.section.adminsHeader": "Owners ({count})",
    "Personnel.section.adminsHeaderLoading": "Owners",
    "Personnel.section.employeesHeader": "Employees ({count})",
    "Personnel.section.employeesHeaderLoading": "Employees",
    "Personnel.section.addAdmin": "Add owner",
    "Personnel.section.ownersEmpty": "No owners yet.",
    "Personnel.section.badgeOwner": "Owner",
    "Personnel.section.badgeRootOwner": "Root owner",
    "Personnel.section.ownerEditUnavailable": "This owner has no staff profile linked yet.",
    "Personnel.section.ownerNoAccount": "Owner · no account",
    "Personnel.card.bookable": "Bookable online",
    "Personnel.card.toComplete": "To complete",
    "Personnel.card.noAccount": "No account",
    "Personnel.seatLimitReachedToast": "Employee limit reached. Upgrade to a higher plan or free up a seat.",
    "Personnel.ownerSeatLimitReachedToast": "Owner limit reached for your plan. Upgrade the subscription or deactivate an existing owner.",
    "Personnel.ownerSeatLimitReachedSalonCap": "Owner limit reached. This limit was set for your salon. Contact Flowcut support to raise it.",
    "Personnel.ownerSeatLimitReachedOverrideToast": "Owner limit reached for this salon. Contact Flowcut support to raise it, or deactivate an existing owner.",
    "Personnel.reactivateLimitReached": "Employee limit reached. Upgrade to a higher plan or free up a seat.",

    // Employee onboarding wizard
    "EmployeeWizard.tabProfile": "Profile",
    "EmployeeWizard.tabSpecializations": "Specializations",
    "EmployeeWizard.tabRates": "Prices & durations",
    "EmployeeWizard.tabCompensation": "Pay",
    "EmployeeWizard.tabAccount": "Account",
    "EmployeeWizard.tabPermissions": "Permissions",

    // Permissions tab inside PersonnelEditor
    "PersonnelEditor.tab.permissions.noAccountTitle": "No login account",
    "PersonnelEditor.tab.permissions.noAccountDesc": "Permissions require a login account. Go to the Account tab to create one.",
    "PersonnelEditor.tab.permissions.presetLabel": "Apply a preset",
    "PersonnelEditor.tab.permissions.presetPlaceholder": "Choose a preset…",
    "PersonnelEditor.tab.permissions.saveButton": "Save permissions",
    "PersonnelEditor.tab.permissions.saving": "Saving…",
    "PersonnelEditor.tab.permissions.successToast": "Permissions saved",
    "PersonnelEditor.tab.permissions.errorToast": "Could not save permissions",
    "PersonnelEditor.tab.permissions.tierClampMultiLocation": "Multi-location is an Enterprise feature: your request was saved without that permission.",
    "PersonnelEditor.tab.permissions.tierClampGeneric": "Some permissions require a higher subscription tier and were not applied",
    "PersonnelEditor.tab.permissions.loadError": "Could not load current permissions",
    "PersonnelEditor.tab.permissions.rootOwnerBannerTitle": "Root owner",
    "PersonnelEditor.tab.permissions.rootOwnerBannerBody": "Permissions cannot be modified. The root owner retains full permanent access to the application.",
    "PersonnelEditor.tab.permissions.customBasedOn": "Custom (based on {preset})",
    "PersonnelEditor.tab.permissions.customNoPreset": "Custom",
    "PersonnelEditor.tab.permissions.customHint": "This matrix has been edited manually.",
    "PersonnelEditor.tab.permissions.revertToPreset": "Revert to the {preset} preset",
    "PersonnelEditor.adminCreate.profileHint": "This owner will only appear on the calendar after this profile is filled out.",
    "PersonnelEditor.adminCreate.requiresProfile": "Fill out the profile first to configure this section.",
    "PersonnelEditor.adminCreate.permissionsRequireAccount": "Create the owner account first to configure permissions.",
    "PersonnelEditor.tab.permissions.editOwnerTitle": "Edit owner",
    "PersonnelEditor.tab.permissions.addOwnerTitle": "Add owner",
    "EmployeeWizard.previous": "Previous",
    "EmployeeWizard.next": "Next",
    "EmployeeWizard.ratesHelp": "Set a price and duration for every service this employee can perform. The list comes from the specializations selected in the previous step.",
    "EmployeeWizard.ratesNoEligibleServices": "No eligible services. Pick at least one section or subsection in the Specializations tab to configure prices.",
    "EmployeeWizard.ratesAllRequired": "Please fill a price and a duration for every eligible service before saving.",
    "EmployeeWizard.ratesFilledLabel": "filled",
    "EmployeeWizard.levelPricing.available": "Level {level} has prices for {covered} of the {total} services on this profile.",
    "EmployeeWizard.levelPricing.availableOne": "Level {level} has prices for the only service on this profile.",
    "EmployeeWizard.levelPricing.willReplace": "{count} values already entered will be replaced.",
    "EmployeeWizard.levelPricing.willReplaceOne": "1 value already entered will be replaced.",
    "EmployeeWizard.levelPricing.apply": "Apply the level prices",
    "EmployeeWizard.levelPricing.applied": "Level {level} prices applied.",
    "EmployeeWizard.levelPricing.loadFailed": "Could not load the level prices.",

    // Interests
    "interests.hiking": "Hiking",
    "interests.running": "Running",
    "interests.cycling": "Cycling",
    "interests.yoga": "Yoga",
    "interests.fitness": "Fitness",
    "interests.swimming": "Swimming",
    "interests.climbing": "Climbing",
    "interests.camping": "Camping",
    "interests.fishing": "Fishing",
    "interests.beach": "Beach trips",
    "interests.painting": "Painting",
    "interests.photography": "Photography",
    "interests.filmmaking": "Filmmaking",
    "interests.theatre": "Theatre",
    "interests.writing": "Writing",
    "interests.music": "Music",
    "interests.singing": "Singing",
    "interests.instruments": "Playing instruments",
    "interests.crafting": "Crafting",
    "interests.djing": "DJing",
    "interests.cooking": "Cooking",
    "interests.baking": "Baking",
    "interests.coffee": "Coffee culture",
    "interests.wine": "Wine tasting",
    "interests.restaurants": "Trying new restaurants",
    "interests.meditation": "Meditation",
    "interests.reading": "Reading",
    "interests.gardening": "Gardening",
    "interests.relaxation": "Relaxation",
    "interests.adventure": "Travel & Adventure",
    "interests.exploring": "Exploring new cities",
    "interests.tropical": "Tropical vacations",
    "interests.roadtrips": "Road trips",
    "interests.culture": "Cultural sightseeing",
    "interests.gaming": "Gaming",
    "interests.technology": "Technology",
    "interests.movies": "Movies",
    "interests.tvshows": "TV shows",
    "interests.podcasts": "Podcasts",
    "interests.socializing": "Meeting new people",
    "interests.animals": "Animal care",
    "interests.dancing": "Dancing",
    "interests.events": "Events & parties",
    "interests.education": "Education",
    "interests.entrepreneurship": "Entrepreneurship",
    "interests.investing": "Investing",
    "interests.publicspeaking": "Public speaking",
    "interests.puzzles": "Puzzles & brain games",

    // FAQ Section


    // Terms of Service (Conditions of Use)

    // Privacy Policy

    // Refund Policy

    // Employees
    "Employees.title": "Employees",
    "Employees.teamTitle": "My Team",
    "Employees.description": "Manage your salon employees and their permissions",
    "Employees.addEmployee": "Add Employee",
    "Employees.addEmployeeDescription": "Create a new employee account with access to the dashboard",
    "Employees.fullName": "Full Name",
    "Employees.email": "Email",
    "Employees.password": "Password",
    "Employees.passwordHint": "Min. 10 characters, with an uppercase letter, a lowercase letter, a number and a special character",
    "Employees.cancel": "Cancel",
    "Employees.create": "Create Employee",
    "Employees.accessDenied": "You do not have permission to access this section.",
    "Employees.errorLoading": "Failed to load employees",
    "Employees.errorEmailInvalid": "Please enter a valid email address",
    "Employees.errorNameInvalid": "Name must be at least 2 characters",
    "Employees.errorPasswordTooShort": "Password must be at least 10 characters",
    "Employees.errorNotAuthenticated": "You must be logged in to create an employee",
    "Employees.errorDuplicate": "An employee with this email already exists",
    "Employees.errorGeneric": "Failed to create employee. Please try again.",
    "Employees.successCreated": "Employee created successfully",
    "Employees.confirmDelete": "Are you sure you want to delete this employee?",
    "Employees.successDeleted": "Employee deleted successfully",
    "Employees.errorDeleting": "Failed to delete employee",
    "Employees.markAsInactive": "Mark as inactive",
    "Employees.inactiveExplanation": "The employee will no longer appear in the calendar or new bookings. All their data is preserved.",
    "Employees.deactivateBlockedTitle": "Future appointments assigned",
    "Employees.deactivateBlockedDescription": "This employee has {count} upcoming appointments. Cancel or reassign them before deactivating.",
    "Employees.deactivateSuccess": "Employee deactivated",
    "Employees.reactivateSuccess": "Employee reactivated",
    "Employees.inactiveBadge": "Inactive",
    "Employees.inactiveSectionTitle": "Inactive employees",
    "Employees.toast.deactivationFailed": "Could not update employee status",
    "Employees.permissionsTitle": "Employee Permissions",
    "Employees.permissionsDescription": "These are the features employees can access based on your subscription plan",
    "Employees.permissionCalendar": "Calendar & Appointments",
    "Employees.permissionCustomerFiles": "Customer Files",
    "Employees.permissionInvoicing": "Invoicing",
    "Employees.permissionInventory": "Inventory",
    "Employees.permissionAIVoice": "AI Voice Agent",
    "Employees.enterpriseFeaturesTitle": "Enterprise Plan Features",
    "Employees.enterpriseFeaturesDescription": "With the Enterprise plan, your employees have access to:",
    "Employees.noEmployees": "No employees yet. Add your first employee to get started.",
    "Employees.employees": "Employees",
    "Employees.locationSpecific": "Employees are specific to each location",

    // Employees additional
    "Employees.linkedHairdresser": "Linked Employee Profile",
    "Employees.selectHairdresser": "Select an employee profile",
    "Employees.noLinkedHairdresser": "None (receptionist)",
    "Employees.noUnlinkedHairdressers": "All profiles are already linked",
    "Employees.linkedHairdresserRequired": "You must select an employee profile",
    "Employees.editAccount": "Edit Account",
    "Employees.editAccountDescription": "Modify account details",
    "Employees.successUpdated": "Account updated successfully",
    "Employees.errorUpdating": "Error updating account",
    "Personnel.publicProfile.title": "Online profile",
    "Personnel.publicProfile.badge": "Visible to your clients",
    "Personnel.publicProfile.description": "This section appears when a client clicks \"View profile\" on your booking page.",
    "Personnel.internalFile.title": "Internal file",
    "Personnel.internalFile.badge": "Never published",
    "Personnel.internalFile.description": "Visible only to the owner, authorized managers and the employee themself.",
    "Personnel.internalFile.loadFailed": "The internal file could not be loaded. These fields are locked so nothing gets erased. Reopen the profile to try again.",
    "Personnel.nickname.label": "Nickname",
    "Personnel.nickname.help": "Shown on your booking page and on the calendar column.",
    "Personnel.nickname.required": "Nickname is required",
    "Personnel.fullName.label": "Full name",
    "Personnel.fullName.help": "For your records and the payroll report. Never shown to clients.",
    "Personnel.social.title": "Social media",
    "Personnel.social.help": "A network left empty shows no icon.",
    "Personnel.social.instagram": "Instagram",
    "Personnel.social.facebook": "Facebook",
    "Personnel.social.tiktok": "TikTok",
    "Personnel.social.placeholder": "Link or @handle",
    "Personnel.social.invalid": "This {network} link is not valid. Paste the profile link or the @handle.",
    "Personnel.identity.forbidden": "You are not allowed to edit this person's profile.",
    "Personnel.contact.title": "Contact details",
    "Personnel.contact.email": "Email",
    "Personnel.contact.mobilePhone": "Mobile phone",
    "Personnel.contact.homePhone": "Home phone",
    "Personnel.contact.emailInvalid": "The email is not valid.",
    "Personnel.contact.mobilePhoneInvalid": "The mobile number is not valid.",
    "Personnel.contact.homePhoneInvalid": "The home phone number is not valid.",
    "Personnel.address.title": "Address",
    "Personnel.address.street": "Street",
    "Personnel.address.city": "City",
    "Personnel.address.province": "Province",
    "Personnel.address.postalCode": "Postal code",
    "Personnel.address.postalCodeInvalid": "The postal code must look like A1A 1A1.",
    "Personnel.province.QC": "Quebec",
    "Personnel.province.ON": "Ontario",
    "Personnel.province.BC": "British Columbia",
    "Personnel.province.AB": "Alberta",
    "Personnel.province.MB": "Manitoba",
    "Personnel.province.SK": "Saskatchewan",
    "Personnel.province.NS": "Nova Scotia",
    "Personnel.province.NB": "New Brunswick",
    "Personnel.province.NL": "Newfoundland and Labrador",
    "Personnel.province.PE": "Prince Edward Island",
    "Personnel.province.YT": "Yukon",
    "Personnel.province.NT": "Northwest Territories",
    "Personnel.province.NU": "Nunavut",
    "Personnel.social.openProfile": "{name}'s {network}",
  },
  fr: {

    // HairdresserSelector
    "hairdresser.title": "Choisissez votre employé(e)",
    "hairdresser.subtitle": "Sélectionnez votre employé(e) préféré(e)",
    "hairdresser.noHairdressers": "Aucun employé disponible",
    "hairdresser.anyProfessional": "N'importe quel professionnel",
    "hairdresser.maxAvailability": "Disponibilité maximale",
    "hairdresser.noEmployeeAvailable": "Aucun employé disponible",
    "hairdresser.noEmployeeAvailableDescription": "Aucun employé n'est actuellement disponible pour la réservation en ligne pour le service sélectionné. Veuillez contacter le salon directement.",
    "hairdresser.noEmployeeCanPerformAll": "Aucun employé ne peut effectuer tous les services sélectionnés.",
    "hairdresser.aboutMe": "À propos de moi",
    "hairdresser.interests": "Intérêts",
    "hairdresser.portfolio": "Portfolio",
    "hairdresser.tellUsAbout": "Parlez-nous de vous...",

    // HairdresserSelector
    "hairdresser.viewProfile": "Voir le profil",

    // HairdressersView
    "hairdresserView.quote": "Citation",
    "hairdresserView.quotePlaceholder": "Entrer une citation",
    "hairdresserView.error": "Erreur",
    "hairdresserView.nameRequired": "Le nom de l'employé est requis",
    "hairdresserView.aboutMeTooLong": "À propos doit contenir 200 caractères ou moins",
    "hairdresserView.noSalonFound": "Aucun salon trouvé",
    "hairdresserView.maxPortfolioImages": "Maximum 6 images de portfolio autorisées",
    "hairdresserView.selectImageFiles": "Veuillez sélectionner uniquement des fichiers image",
    "hairdresserView.selectValidImage": "Veuillez sélectionner un fichier image valide",

    // Type de personnel
    "Personnel.typeLabel": "Type",
    "Personnel.typePrestataire": "Prestataire",
    "Personnel.typeAssistant": "Assistant",
    "Personnel.typeReceptionniste": "Réceptionniste",
    "Personnel.typeGerant": "Gérant",
    "Personnel.typeProprietaire": "Propriétaire",
    "Personnel.owner.showOnCalendar": "Afficher au calendrier",
    "Personnel.owner.showOnCalendarHint": "Ajoute une colonne au calendrier pour ce propriétaire et le rend réservable en ligne.",
    "Personnel.showInPayroll": "Afficher dans la paie",
    "Personnel.showInPayrollHint": "Fait figurer cette personne dans le tableau de paie. Masquée, elle n'y apparaît plus, même si elle a des heures ou des ventes dans la période.",
    "Personnel.aboutMeMax": "(max 200 caractères)",
    "Personnel.color.automatic": "Couleur automatique",
    "Personnel.charCountSuffix": "/200 caractères",
    "Personnel.portfolioMaxImages": "Portfolio (max 6 images)",
    "Personnel.imagePreviewAlt": "Aperçu de la photo de profil",
    "Personnel.portfolioImageAlt": "Photo du portfolio {n}",
    "Personnel.portfolioNewImageAlt": "Nouvelle photo du portfolio {n}",
    "Personnel.statusLabel": "Statut",
    "Personnel.statusActive": "Actif",
    "Personnel.statusInactive": "Inactif",
    "Personnel.status.lockedRootOwner": "Le propriétaire fondateur du salon ne peut pas être désactivé. Son compte a créé le salon et doit rester actif.",
    "Personnel.status.lockedSelf": "Vous ne pouvez pas désactiver votre propre fiche. Demandez à un autre propriétaire de le faire.",
    "Personnel.deactivateAction": "Marquer comme inactif (départ)",
    "Personnel.reactivateAction": "Réactiver",
    "Personnel.deactivateDialogTitle": "Marquer comme inactif ?",
    "Personnel.deactivateDialogDescription": "Ce membre sera retiré des réservations en ligne et du calendrier, et son accès sera désactivé. Tout l'historique (rendez-vous, factures, paie, statistiques) est conservé. Cette action est réversible.",
    "Personnel.deactivateDialogConsequences": "Conséquences",
    "Personnel.deactivateConsequence1": "N'apparaît plus dans les réservations en ligne",
    "Personnel.deactivateConsequence2": "Retiré du calendrier",
    "Personnel.deactivateConsequence3": "Accès au compte désactivé",
    "Personnel.deactivateConsequence4": "Tout l'historique est conservé",
    "Personnel.deactivateConsequence5": "Réversible à tout moment",
    "Personnel.deactivateConfirm": "Confirmer la désactivation",
    "Personnel.deactivateBlockedMessage": "{count} rendez-vous à venir doivent d'abord être réassignés ou annulés.",
    "Personnel.reactivateDialogTitle": "Réactiver ce membre ?",
    "Personnel.reactivateDialogDescription": "Son accès sera rétabli et il sera à nouveau visible dans les réservations et le calendrier.",
    "Personnel.reactivateConfirm": "Réactiver",
    "Personnel.deleteFiche.label": "Supprimer le compte",
    "Personnel.deleteFiche.hint": "Supprimer définitivement le compte de connexion. Le nom reste sur les factures et rendez-vous passés.",
    "Personnel.deleteFiche.action": "Supprimer définitivement",
    "Personnel.deleteFiche.dialogTitle": "Supprimer définitivement ce compte ?",
    "Personnel.deleteFiche.dialogDescription": "Le compte de connexion et les données personnelles sont supprimés et l'adresse courriel est libérée pour réutilisation. L'historique de l'employé (factures, rendez-vous, paie) est conservé sous son nom. Cette action est irréversible.",
    "Personnel.deleteFiche.consequence1": "Compte de connexion et courriel supprimés définitivement",
    "Personnel.deleteFiche.consequence2": "Nom conservé sur les factures et rendez-vous",
    "Personnel.deleteFiche.consequence3": "Irréversible : le membre ne pourra pas être réactivé",
    "Personnel.deleteFiche.confirm": "Supprimer définitivement",
    "Personnel.deleteFiche.success": "Compte supprimé",
    "Personnel.deleteFiche.noAccount.label": "Supprimer la fiche",
    "Personnel.deleteFiche.noAccount.hint": "Retirer définitivement cette fiche du module. Le nom reste sur les factures et rendez-vous passés.",
    "Personnel.deleteFiche.noAccount.dialogTitle": "Supprimer définitivement cette fiche ?",
    "Personnel.deleteFiche.noAccount.dialogDescription": "La fiche disparaît du module pour de bon. L'historique (factures, rendez-vous, paie) reste conservé sous son nom. Cette personne n'a aucun compte de connexion, il n'y a donc rien à libérer. Cette action est irréversible.",
    "Personnel.deleteFiche.noAccount.consequence1": "Fiche retirée du module, définitivement",
    "Personnel.deleteFiche.noAccount.consequence2": "Nom conservé sur les factures et rendez-vous",
    "Personnel.deleteFiche.noAccount.consequence3": "Irréversible : la fiche ne pourra pas être réactivée",
    "Personnel.deleteFiche.noAccount.success": "Fiche supprimée",
    "Personnel.deleteFiche.failed": "Impossible de supprimer le compte",
    "Personnel.account.revoke.label": "Retirer l'accès",
    "Personnel.account.revoke.hint": "Supprimer ce compte de connexion. La personne garde sa fiche, son historique et ses rendez-vous.",
    "Personnel.account.revoke.action": "Retirer l'accès",
    "Personnel.account.revoke.dialogTitle": "Retirer ce compte de connexion ?",
    "Personnel.account.revoke.dialogDescription": "Le compte de connexion est supprimé et l'adresse courriel redevient disponible. Vous pourrez créer un nouveau compte sur la même fiche juste après.",
    "Personnel.account.revoke.consequence1": "Adresse courriel libérée et réutilisable",
    "Personnel.account.revoke.consequence2": "Fiche, historique et rendez-vous intacts",
    "Personnel.account.revoke.consequence3": "La personne travaille toujours ici et sa fiche reste active. Le siège reste compté, sauf pour un propriétaire sans fiche active : son siège est alors libéré.",
    "Personnel.account.revoke.consequence4": "Les permissions personnalisées sont perdues et réinitialisées à la création d'un nouveau compte",
    "Personnel.account.revoke.confirm": "Retirer l'accès",
    "Personnel.account.revoke.success": "Accès retiré",
    "Personnel.account.revoke.failed": "Impossible de retirer l'accès",
    "Personnel.account.revoke.modeMismatch": "Le serveur n'a pas fait ce qui était demandé. La fiche a peut-être été archivée et masquée. Ouvrez-la et vérifiez avant d'aller plus loin.",
    "Personnel.account.revoke.stillReferenced": "Ce compte ne peut pas être supprimé car il est référencé ailleurs dans l'application. Rien n'a été modifié. Contactez le support.",
    "Personnel.account.revoke.refused.self": "Vous ne pouvez pas retirer votre propre compte de connexion. Demandez à un autre propriétaire de le faire.",
    "Personnel.account.revoke.refused.founding_owner": "Le compte du propriétaire fondateur ne peut pas être retiré. Il a créé le salon et doit rester actif.",
    "Personnel.account.revoke.refused.last_owner": "C'est le dernier compte propriétaire du salon. Le retirer fermerait la porte à tout le monde.",
    "Personnel.account.refused.targetNotStaff": "Ce compte est un compte propriétaire ou n'appartient pas au personnel de votre salon. Aucune modification n'a été faite.",
    "Personnel.account.revoke.lockedRootOwner": "Le compte du propriétaire fondateur ne peut pas être retiré. Il a créé le salon et doit rester actif.",
    "Personnel.account.revoke.lockedSelf": "Vous ne pouvez pas retirer votre propre compte de connexion. Demandez à un autre propriétaire de le faire.",

    // PresenceLocationsField (employés multi-succursales)
    "Personnel.presences.title": "Succursales où {name} travaille",
    "Personnel.presences.primary": "Succursale principale de sa fiche",
    "Personnel.presences.removeTitle": "Retirer {name} de {location} ?",
    "Personnel.presences.futureAppointments": "{count} rendez-vous à venir dans cette succursale. Ils restent au calendrier.",
    "Personnel.presences.futureAppointmentsError": "Impossible de vérifier les rendez-vous à venir dans cette succursale. S'il y en a, ils restent au calendrier.",
    "Personnel.presences.removeConfirm": "Retirer de {location}",
    "Personnel.presences.removing": "Retrait en cours...",
    "Personnel.presences.twoLocationsHint": "Deux succursales : {name} verra le sélecteur de succursale dans son app.",
    "Personnel.presences.errors.homeSalon": "Cette succursale est déjà la succursale principale de cette fiche.",
    "Personnel.presences.errors.isPrimary": "La succursale principale d'une fiche ne peut pas être retirée.",
    "Personnel.presences.errors.mustPointToPrimary": "Ouvrez la fiche principale de cette personne pour modifier ses succursales.",
    "Personnel.presences.errors.notFound": "Cette succursale était déjà retirée. Rouvrez la fiche pour voir l'état à jour.",
    "Personnel.presences.errors.primaryDeactivated": "Cette personne est inactive. Réactivez-la avant d'ajouter une succursale.",
    "Personnel.presences.errors.notAllowed": "Vous n'avez pas le droit de modifier les succursales de cette personne. Il faut être propriétaire, ou gestionnaire autorisé à ajouter des employés dans les deux succursales.",
    "Personnel.presences.errors.generic": "Impossible de modifier les succursales. Veuillez réessayer.",
    "Personnel.presences.switcherLabel": "Succursale",
    "Personnel.presences.prefilledBanner": "Pré-rempli depuis {location} grâce aux services liés. Rien n'est encore enregistré : vérifiez, puis enregistrez.",
    "Personnel.presences.prefilledFrom": "pré-coché depuis « {service} »",
    "Personnel.presences.priceHint": "{location} : {price}",
    "Personnel.presences.unsavedTitle": "Vos modifications pour {location} ne sont pas encore enregistrées.",
    "Personnel.presences.unsavedBody": "Enregistrez-les avant de changer de succursale, ou abandonnez-les.",
    "Personnel.presences.unsavedStay": "Rester sur {location}",
    "Personnel.presences.unsavedDiscard": "Abandonner et ouvrir {location}",
    "Personnel.rates.readOnlyNeedsServices": "Les spécialisations, les prix et les durées se modifient avec la permission Services.",

    // Personnel — onglet Compte
    "Personnel.account.saveFirst": "Sauvegardez le profil avant de créer un compte de connexion.",
    "Personnel.account.enterNameFirst": "Entrez d'abord un nom pour cette personne.",
    "Personnel.account.noAccount": "Ce membre de l'équipe n'a pas encore de compte de connexion. Créez-en un pour lui donner accès au tableau de bord.",
    "Personnel.account.createAction": "Créer un compte de connexion",
    "Personnel.account.createSubmit": "Créer le compte",
    "Personnel.account.associateAction": "Associer un compte existant",
    "Personnel.account.associateSubmit": "Associer le compte",
    "Personnel.account.associatePlaceholder": "Choisir un compte",
    "Personnel.account.associateEmpty": "Aucun compte sans fiche disponible",
    "Personnel.account.successAssociated": "Compte associé",
    "Personnel.account.personAlreadyLinked": "Cette fiche est déjà liée à un compte. Retirez d'abord l'accès du compte actuel.",
    "Personnel.account.accountAlreadyLinked": "Ce compte est déjà lié à une autre fiche du personnel.",
    "Personnel.account.passwordHint": "Min. 10 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial",
    "Personnel.account.errorPasswordMin10": "Le mot de passe doit contenir au moins 10 caractères",
    "Personnel.account.successCreated": "Compte de connexion créé avec succès",
    "Personnel.account.warnPermissionsNotSeeded": "Compte créé, mais les permissions par défaut n'ont pas pu être appliquées. Configurez-les manuellement dans l'onglet Permissions.",
    "Personnel.account.accountActive": "Compte de connexion",
    "Personnel.account.activeBadge": "Actif",
    "Personnel.account.emailUnknown": "Courriel indisponible",
    "Personnel.account.resetDesc": "Envoyer un courriel de réinitialisation du mot de passe à ce membre de l'équipe.",
    "Personnel.account.resetAction": "Envoyer la réinitialisation",
    "Personnel.account.resetSent": "Courriel envoyé",
    "Personnel.account.resetSentDesc": "Les instructions de réinitialisation ont été envoyées par courriel.",

    // Personnel — création d'employé (choix de sous-emplacement, Phase 6 T15)
    "Personnel.create.locationLabel": "Travaille à quel emplacement ?",
    "Personnel.create.locationPlaceholder": "Choisir un emplacement...",

    // Personnel — section Employé unifiée
    "Personnel.section.title": "Employé",
    "Personnel.section.addEmployee": "Ajouter employé",
    "Personnel.section.employeeLimitReached": "Limite d'employés atteinte ({current}/{max}). Passez à un forfait supérieur pour en ajouter.",
    "Personnel.section.employeeLimitReachedSalonCap": "Limite d'employés atteinte ({current}/{max}). Cette limite a été fixée pour votre salon. Contactez le soutien Flowcut pour l'augmenter.",
    "Personnel.section.empty": "Aucun employé pour le moment. Ajoutez votre premier employé pour commencer.",
    "Personnel.section.inactiveTitle": "Personnel inactif",
    "Personnel.section.orphanTitle": "Comptes sans fiche",
    "Personnel.section.orphanDescription": "Ces comptes de connexion ne sont liés à aucune fiche d'employé. Modifiez un employé et liez le compte, ou recréez la fiche.",
    "Personnel.section.errorLoading": "Impossible de charger le personnel. Veuillez réessayer.",
    "Personnel.section.tabEmployees": "Employés",
    "Personnel.section.tabOwners": "Propriétaires",
    "Personnel.section.adminsHeader": "Propriétaires ({count})",
    "Personnel.section.adminsHeaderLoading": "Propriétaires",
    "Personnel.section.employeesHeader": "Employés ({count})",
    "Personnel.section.employeesHeaderLoading": "Employés",
    "Personnel.section.addAdmin": "Ajouter propriétaire",
    "Personnel.section.ownersEmpty": "Aucun propriétaire pour le moment.",
    "Personnel.section.badgeOwner": "Propriétaire",
    "Personnel.section.badgeRootOwner": "Propriétaire racine",
    "Personnel.section.ownerEditUnavailable": "Ce propriétaire n'a pas encore de fiche personnel liée.",
    "Personnel.section.ownerNoAccount": "Propriétaire · sans compte",
    "Personnel.card.bookable": "Réservable en ligne",
    "Personnel.card.toComplete": "À compléter",
    "Personnel.card.noAccount": "Aucun compte",
    "Personnel.seatLimitReachedToast": "Limite d'employés atteinte. Passez à un forfait supérieur ou libérez une place.",
    "Personnel.ownerSeatLimitReachedToast": "Limite de propriétaires atteinte pour votre forfait. Mettez à niveau l'abonnement ou désactivez un propriétaire existant.",
    "Personnel.ownerSeatLimitReachedSalonCap": "Limite de propriétaires atteinte. Cette limite a été fixée pour votre salon. Contactez le soutien Flowcut pour l'augmenter.",
    "Personnel.ownerSeatLimitReachedOverrideToast": "Limite de propriétaires atteinte pour ce salon. Contactez le soutien Flowcut pour l'augmenter, ou désactivez un propriétaire existant.",
    "Personnel.reactivateLimitReached": "Limite d'employés atteinte. Passez à un forfait supérieur ou libérez une place.",

    // Onboarding employé (wizard)
    "EmployeeWizard.tabProfile": "Profil",
    "EmployeeWizard.tabSpecializations": "Spécialisations",
    "EmployeeWizard.tabRates": "Prix et durées",
    "EmployeeWizard.tabCompensation": "Rémunération",
    "EmployeeWizard.tabAccount": "Compte",
    "EmployeeWizard.tabPermissions": "Permissions",

    // Onglet Permissions dans PersonnelEditor
    "PersonnelEditor.tab.permissions.noAccountTitle": "Aucun compte de connexion",
    "PersonnelEditor.tab.permissions.noAccountDesc": "Les permissions nécessitent un compte de connexion. Rendez-vous dans l'onglet Compte pour en créer un.",
    "PersonnelEditor.tab.permissions.presetLabel": "Appliquer un préréglage",
    "PersonnelEditor.tab.permissions.presetPlaceholder": "Choisir un préréglage…",
    "PersonnelEditor.tab.permissions.saveButton": "Enregistrer les permissions",
    "PersonnelEditor.tab.permissions.saving": "Enregistrement…",
    "PersonnelEditor.tab.permissions.successToast": "Permissions enregistrées",
    "PersonnelEditor.tab.permissions.errorToast": "Impossible d'enregistrer les permissions",
    "PersonnelEditor.tab.permissions.tierClampMultiLocation": "Le multi-établissement est une fonctionnalité Enterprise : votre demande a été enregistrée sans cette permission.",
    "PersonnelEditor.tab.permissions.tierClampGeneric": "Certaines permissions nécessitent un forfait supérieur et n'ont pas été appliquées",
    "PersonnelEditor.tab.permissions.loadError": "Impossible de charger les permissions actuelles",
    "PersonnelEditor.tab.permissions.rootOwnerBannerTitle": "Propriétaire racine",
    "PersonnelEditor.tab.permissions.rootOwnerBannerBody": "Permissions non modifiables. Le propriétaire racine conserve un accès complet permanent à l'application.",
    "PersonnelEditor.tab.permissions.customBasedOn": "Personnalisé (basé sur {preset})",
    "PersonnelEditor.tab.permissions.customNoPreset": "Personnalisé",
    "PersonnelEditor.tab.permissions.customHint": "Cette matrice a été modifiée à la main.",
    "PersonnelEditor.tab.permissions.revertToPreset": "Revenir au préréglage {preset}",
    "PersonnelEditor.adminCreate.profileHint": "Ce propriétaire n'apparaîtra au calendrier qu'après avoir rempli ce profil.",
    "PersonnelEditor.adminCreate.requiresProfile": "Remplissez d'abord le profil pour configurer cette section.",
    "PersonnelEditor.adminCreate.permissionsRequireAccount": "Créez d'abord le compte propriétaire pour configurer les permissions.",
    "PersonnelEditor.tab.permissions.editOwnerTitle": "Modifier le propriétaire",
    "PersonnelEditor.tab.permissions.addOwnerTitle": "Ajouter un propriétaire",
    "EmployeeWizard.previous": "Précédent",
    "EmployeeWizard.next": "Suivant",
    "EmployeeWizard.ratesHelp": "Renseignez un prix et une durée pour chaque service que cet employé peut effectuer. La liste provient des spécialisations choisies à l'étape précédente.",
    "EmployeeWizard.ratesNoEligibleServices": "Aucun service éligible. Sélectionnez au moins une section ou sous-section dans l'onglet Spécialisations pour configurer les prix.",
    "EmployeeWizard.ratesAllRequired": "Renseignez un prix et une durée pour chaque service éligible avant de sauvegarder.",
    "EmployeeWizard.ratesFilledLabel": "renseignés",
    "EmployeeWizard.levelPricing.available": "Le niveau {level} a des prix pour {covered} des {total} services de cette fiche.",
    "EmployeeWizard.levelPricing.availableOne": "Le niveau {level} a des prix pour le seul service de cette fiche.",
    "EmployeeWizard.levelPricing.willReplace": "{count} valeurs déjà saisies seront remplacées.",
    "EmployeeWizard.levelPricing.willReplaceOne": "1 valeur déjà saisie sera remplacée.",
    "EmployeeWizard.levelPricing.apply": "Appliquer les prix du niveau",
    "EmployeeWizard.levelPricing.applied": "Prix du niveau {level} appliqués.",
    "EmployeeWizard.levelPricing.loadFailed": "Impossible de charger les prix du niveau.",

    // Interests
    "interests.hiking": "Randonnée",
    "interests.running": "Course à pied",
    "interests.cycling": "Vélo",
    "interests.yoga": "Yoga",
    "interests.fitness": "Fitness",
    "interests.swimming": "Natation",
    "interests.climbing": "Escalade",
    "interests.camping": "Camping",
    "interests.fishing": "Pêche",
    "interests.beach": "Plage",
    "interests.painting": "Peinture",
    "interests.photography": "Photographie",
    "interests.filmmaking": "Cinéma",
    "interests.theatre": "Théâtre",
    "interests.writing": "Écriture",
    "interests.music": "Musique",
    "interests.singing": "Chant",
    "interests.instruments": "Jouer des instruments",
    "interests.crafting": "Artisanat",
    "interests.djing": "DJ",
    "interests.cooking": "Cuisine",
    "interests.baking": "Pâtisserie",
    "interests.coffee": "Culture du café",
    "interests.wine": "Dégustation de vin",
    "interests.restaurants": "Nouveaux restaurants",
    "interests.meditation": "Méditation",
    "interests.reading": "Lecture",
    "interests.gardening": "Jardinage",
    "interests.relaxation": "Relaxation",
    "interests.adventure": "Voyage & Aventure",
    "interests.exploring": "Explorer de nouvelles villes",
    "interests.tropical": "Vacances tropicales",
    "interests.roadtrips": "Road trips",
    "interests.culture": "Visites culturelles",
    "interests.gaming": "Jeux vidéo",
    "interests.technology": "Technologie",
    "interests.movies": "Cinéma",
    "interests.tvshows": "Séries télé",
    "interests.podcasts": "Podcasts",
    "interests.socializing": "Rencontrer des gens",
    "interests.animals": "Soins des animaux",
    "interests.dancing": "Danse",
    "interests.events": "Événements & fêtes",
    "interests.education": "Éducation",
    "interests.entrepreneurship": "Entrepreneuriat",
    "interests.investing": "Investissement",
    "interests.publicspeaking": "Prise de parole en public",
    "interests.puzzles": "Jeux de réflexion",

    // FAQ Section


    // Terms of Service - French

    // Privacy Policy - French

    // Refund Policy - French

    // Employés
    "Employees.title": "Employés",
    "Employees.teamTitle": "Mon équipe",
    "Employees.description": "Gérez vos employés de salon et leurs permissions",
    "Employees.addEmployee": "Ajouter employé",
    "Employees.addEmployeeDescription": "Créer un nouveau compte employé avec accès au tableau de bord",
    "Employees.fullName": "Nom complet",
    "Employees.email": "Courriel",
    "Employees.password": "Mot de passe",
    "Employees.passwordHint": "Min. 10 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial",
    "Employees.cancel": "Annuler",
    "Employees.create": "Créer l'employé",
    "Employees.accessDenied": "Vous n'avez pas la permission d'accéder à cette section.",
    "Employees.errorLoading": "Échec du chargement des employés",
    "Employees.errorEmailInvalid": "Veuillez entrer une adresse courriel valide",
    "Employees.errorNameInvalid": "Le nom doit contenir au moins 2 caractères",
    "Employees.errorPasswordTooShort": "Le mot de passe doit contenir au moins 10 caractères",
    "Employees.errorNotAuthenticated": "Vous devez être connecté pour créer un employé",
    "Employees.errorDuplicate": "Un employé avec ce courriel existe déjà",
    "Employees.errorGeneric": "Échec de la création de l'employé. Veuillez réessayer.",
    "Employees.successCreated": "Employé créé avec succès",
    "Employees.confirmDelete": "Êtes-vous sûr de vouloir supprimer cet employé ?",
    "Employees.successDeleted": "Employé supprimé avec succès",
    "Employees.errorDeleting": "Échec de la suppression de l'employé",
    "Employees.markAsInactive": "Employé inactif",
    "Employees.inactiveExplanation": "L'employé n'apparaîtra plus dans le calendrier ni dans les nouveaux rendez-vous. Toutes ses données sont préservées.",
    "Employees.deactivateBlockedTitle": "Rendez-vous futurs assignés",
    "Employees.deactivateBlockedDescription": "Cet employé a {count} rendez-vous futurs. Annulez ou réassignez-les avant de le désactiver.",
    "Employees.deactivateSuccess": "Employé désactivé",
    "Employees.reactivateSuccess": "Employé réactivé",
    "Employees.inactiveBadge": "Inactif",
    "Employees.inactiveSectionTitle": "Employés inactifs",
    "Employees.toast.deactivationFailed": "Impossible de mettre à jour le statut de l'employé",
    "Employees.permissionsTitle": "Permissions des employés",
    "Employees.permissionsDescription":
      "Voici les fonctionnalités auxquelles les employés peuvent accéder selon votre plan d'abonnement",
    "Employees.permissionCalendar": "Calendrier et rendez-vous",
    "Employees.permissionCustomerFiles": "Dossiers clients",
    "Employees.permissionInvoicing": "Facturation",
    "Employees.permissionInventory": "Inventaire",
    "Employees.permissionAIVoice": "Agent IA vocale",
    "Employees.enterpriseFeaturesTitle": "Fonctionnalités du plan Entreprise",
    "Employees.enterpriseFeaturesDescription": "Avec le plan Entreprise, vos employés ont accès à :",
    "Employees.noEmployees": "Aucun employé pour le moment. Ajoutez votre premier employé pour commencer.",
    "Employees.employees": "Employés",
    "Employees.locationSpecific": "Les employés sont propres à chaque emplacement",

    // Employés supplémentaires
    "Employees.linkedHairdresser": "Profil employé associé",
    "Employees.selectHairdresser": "Sélectionner un profil employé",
    "Employees.noLinkedHairdresser": "Aucun (réceptionniste)",
    "Employees.noUnlinkedHairdressers": "Tous les profils sont déjà liés",
    "Employees.linkedHairdresserRequired": "Vous devez sélectionner un profil employé",
    "Employees.editAccount": "Modifier le compte",
    "Employees.editAccountDescription": "Modifier les informations du compte",
    "Employees.successUpdated": "Compte mis à jour avec succès",
    "Employees.errorUpdating": "Erreur lors de la mise à jour du compte",
    "Personnel.publicProfile.title": "Profil en ligne",
    "Personnel.publicProfile.badge": "Visible par vos clients",
    "Personnel.publicProfile.description": "Ce bloc apparaît quand un client clique sur « Voir le profil » dans votre page de réservation.",
    "Personnel.internalFile.title": "Dossier interne",
    "Personnel.internalFile.badge": "Jamais publié",
    "Personnel.internalFile.description": "Visible seulement par le propriétaire, les gestionnaires autorisés et l'employé lui-même.",
    "Personnel.internalFile.loadFailed": "Le dossier interne n'a pas pu être chargé. Ces champs sont verrouillés pour ne rien effacer. Rouvrez la fiche pour réessayer.",
    "Personnel.nickname.label": "Surnom",
    "Personnel.nickname.help": "Affiché sur votre page de réservation et sur la colonne du calendrier.",
    "Personnel.nickname.required": "Le surnom est requis",
    "Personnel.fullName.label": "Nom complet",
    "Personnel.fullName.help": "Pour vos dossiers et le rapport de paie. Jamais affiché aux clients.",
    "Personnel.social.title": "Réseaux sociaux",
    "Personnel.social.help": "Un réseau laissé vide n'affiche aucune icône.",
    "Personnel.social.instagram": "Instagram",
    "Personnel.social.facebook": "Facebook",
    "Personnel.social.tiktok": "TikTok",
    "Personnel.social.placeholder": "Lien ou @identifiant",
    "Personnel.social.invalid": "Ce lien {network} n'est pas valide. Collez le lien du profil ou l'@identifiant.",
    "Personnel.identity.forbidden": "Vous n'avez pas le droit de modifier le profil de cette personne.",
    "Personnel.contact.title": "Coordonnées",
    "Personnel.contact.email": "Courriel",
    "Personnel.contact.mobilePhone": "Cellulaire",
    "Personnel.contact.homePhone": "Téléphone domicile",
    "Personnel.contact.emailInvalid": "Le courriel n'est pas valide.",
    "Personnel.contact.mobilePhoneInvalid": "Le numéro de cellulaire n'est pas valide.",
    "Personnel.contact.homePhoneInvalid": "Le numéro de téléphone domicile n'est pas valide.",
    "Personnel.address.title": "Adresse",
    "Personnel.address.street": "Rue",
    "Personnel.address.city": "Ville",
    "Personnel.address.province": "Province",
    "Personnel.address.postalCode": "Code postal",
    "Personnel.address.postalCodeInvalid": "Le code postal doit avoir la forme A1A 1A1.",
    "Personnel.province.QC": "Québec",
    "Personnel.province.ON": "Ontario",
    "Personnel.province.BC": "Colombie-Britannique",
    "Personnel.province.AB": "Alberta",
    "Personnel.province.MB": "Manitoba",
    "Personnel.province.SK": "Saskatchewan",
    "Personnel.province.NS": "Nouvelle-Écosse",
    "Personnel.province.NB": "Nouveau-Brunswick",
    "Personnel.province.NL": "Terre-Neuve-et-Labrador",
    "Personnel.province.PE": "Île-du-Prince-Édouard",
    "Personnel.province.YT": "Yukon",
    "Personnel.province.NT": "Territoires du Nord-Ouest",
    "Personnel.province.NU": "Nunavut",
    "Personnel.social.openProfile": "{network} de {name}",
  },
};
